import { Link } from "react-router-dom";
import { featuredComics } from "@/mocks/comics";
import ComicCard from "@/components/base/ComicCard";

export default function HotComics() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-semibold tracking-wide text-primary-500">今日热榜</span>
            <h2 className="mt-2 text-2xl md:text-4xl">大家都在追的漫画</h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              实时更新的人气佳作，翻页下拉随你切换，追更不落伍。
            </p>
          </div>
          <Link
            to="/comics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-5 md:grid-cols-4">
          {featuredComics.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}